














import {Component, Vue, Prop} from 'vue-property-decorator';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {connectionPModuleSystemLog} from '@/api/configApi';
import {pmoduleStoresByTypeMap} from '@/views/system/modules/configurate';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import {PMProcessSystemType} from '@/views/system/modules/enums';

@Component
export default class LogTabDeveloperInfo extends Vue {
  @Prop()
  pmodule!: PModuleWithMeasurements;

  // Получить хранилище
  get apiStore(): any {
    return (pmoduleStoresByTypeMap.get(this.pmodule.type) as any) as PModuleStoreModule;
  }

  viewLogs: {data: string; id: number}[] = [];

  // Веб сокет лога
  socket!: WebSocket | null;

  //Размер пустого лога
  logMinSizePx = 400;

  // Получить размер лога в px
  get logSizePx() {
    return this.viewLogs.length > 0 ? this.viewLogs.length * 24 : this.logMinSizePx;
  }

  error = false;
  loading = true;

  async created() {
    this.openWS();
  }

  async loadLog() {
    try {
      await this.apiStore.processSystem({
        id: this.pmodule.id,
        action: PMProcessSystemType.EmitLastSystemctlStatus,
      });
    } catch (e) {
      console.log('Error on logs loading: ', e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  beforeDestroy() {
    this.closeWS();
  }

  // Закрыть соединения веб сокета
  closeWS() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }

  // Открыть вебсокет
  openWS() {
    if (!this.pmodule.guid) return;
    this.socket = connectionPModuleSystemLog(this.pmodule.guid);
    this.socket.onmessage = (e: {data: string}) => this.subscribeConnectionWS(e);
    // Запрашивать логи стоит только когда сокет будет открыт
    this.socket.onopen = () => {
      this.loadLog();
    };
  }

  //Действия на веб сокете
  subscribeConnectionWS(e: {data: string}) {
    this.viewLogs = [];
    const strParse = JSON.parse(e.data);
    if (strParse)
      this.viewLogs = strParse
        .split(/^"|\\n"?|\r?\n"?/)
        .filter(Boolean)
        .map((str: string, id: number) => ({data: unescape(str.split('\\').join('%')), id: id}));
  }
}
